import React, { Fragment, useState } from 'react'
import './AuthForm.scss'
import { Formik } from 'formik'

const AuthForm = ({
	type,
	submitForm,
	authErrorMessage,
	setAuthErrorMessage,
}) => {
	return (
		<Formik
			initialValues={{ email: '', password: '', confirm: '' }}
			validateOnChange={false}
			validateOnBlur={false}
			validate={values => {
				const errors = {}
				if (type === 'reset') {
					if (values.confirm !== values.password) {
						errors.password = 'Passwords must match'
					}
					if (values.password.length < 6) {
						errors.password = 'Password must be at least 6 characters'
					}
				} else {
					if (!values.email) {
						errors.email = 'Email is required'
					} else if (
						!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
					) {
						errors.email = 'Invalid email address'
					}
					console.log(type)
					if (type === 'register') {
						if (!values.password) {
							errors.password = 'Password is required'
						}
						if (values.password.length < 6) {
							errors.password = 'Password must be at least 6 characters'
						}
					}
				}
				console.log(errors)
				if (errors.email) {
					setAuthErrorMessage(errors.email)
					setTimeout(() => setAuthErrorMessage(''), 10000)
				} else if (errors.password) {
					setAuthErrorMessage(errors.password)
					setTimeout(() => setAuthErrorMessage(''), 10000)
				}
				return errors
			}}
			onSubmit={(values, { setSubmitting }) => {
				setSubmitting(false)
				submitForm(values)
			}}
		>
			{({
				values,
				errors,
				touched,
				handleChange,
				handleBlur,
				handleSubmit,
				isSubmitting,
				/* and other goodies */
			}) => (
				<Fragment>
					<form className="auth-form" onSubmit={handleSubmit}>
						<div className="form-container">
							{type !== 'reset' ? (
								<div className="row">
									<input
										className="field"
										type="text"
										name="email"
										placeholder="Email"
										onChange={handleChange}
										onBlur={handleBlur}
										value={values.email}
									/>
								</div>
							) : null}
							<div className="row">
								<input
									className="field"
									type="password"
									name="password"
									placeholder="Password"
									onChange={handleChange}
									onBlur={handleBlur}
									value={values.password}
								/>
							</div>
							{type === 'reset' ? (
								<div className="row">
									<input
										className="field"
										type="password"
										name="confirm"
										placeholder="Confirm password"
										onChange={handleChange}
										onBlur={handleBlur}
										value={values.confirm}
									/>
								</div>
							) : null}
							<div className="auth-button-container">
								<div className="border-gradient auth-border-gradient" />
								<button
									className="auth-button"
									type="submit"
									disabled={isSubmitting}
								>
									<span className="gradient-text roboto">Submit</span>
								</button>
							</div>
						</div>
					</form>
					{authErrorMessage.length ? (
						<div
							className={`auth-info${
								authErrorMessage !== 'Reset sent successfully!'
									? ' has-error'
									: ''
							}`}
						>
							{authErrorMessage}
							<span onClick={() => setAuthErrorMessage('')}>&times;</span>
						</div>
					) : null}
				</Fragment>
			)}
		</Formik>
	)
}

export default AuthForm
